import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Radio,
  RadioGroup,
} from '@resy/ui-kitchen';
import cx from 'classnames';
import './SurveyContainer.scss';

import './NPS.scss';

const NPS = ({
  questionIndex,
  options,
  questionsetId,
  questionId,
  answerQuestion,
  leftLabel,
  rightLabel,
}) => {
  const [selected, setSelected] = useState(null);
  const isSelected = (optionId) => selected === optionId;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const allParams = Object.fromEntries(urlParams);

    const { prepop } = allParams;
    if (questionIndex === 0 && typeof prepop !== 'undefined') {
      const prepopulatedOption = options.filter(
        (option) => option.text === `${prepop}`
      );
      if (prepopulatedOption.length === 1) {
        const opt = prepopulatedOption[0];
        setSelected(opt.id);

        answerQuestion(
          questionsetId,
          questionId,
          opt.id,
          null
        );
      }
    }
  }, []);

  return (
    <div className="NPSButtons NPS__question" data-test-id="nps">
      <div className="NPSButtons NPS__question label">
        {leftLabel && <div className="left_label">{leftLabel}</div>}
        <RadioGroup
          className="NPSButtons"
          aria-labelledby="selectedOption"
          onChange={(valueFromRadioGroup) => {
            const chosenOption = options.find(
              (option) => option.id === valueFromRadioGroup
            );
            if (!chosenOption) return;

            setSelected(chosenOption.id);

            answerQuestion(
              questionsetId,
              questionId,
              chosenOption.id,
              null
            );
          }}
        >
          {options.map((option) => (
            <Radio
              id="selectedOption"
              key={option.id}
              value={option.id} // <--- use id as value
              checked={isSelected(option.id)}
              className={cx('NPSButton', { selected: isSelected(option.id) })}
            >
              <div>{option.text}</div>
            </Radio>
          ))}
        </RadioGroup>
        {rightLabel && <div className="right_label">{rightLabel}</div>}
      </div>
    </div>
  );
};

NPS.propTypes = {
  questionIndex: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.number,
      order: PropTypes.number,
    })
  ),
  questionsetId: PropTypes.number,
  questionId: PropTypes.number,
  answerQuestion: PropTypes.func,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
};

NPS.defaultProps = {
  questionIndex: null,
  options: [],
  questionsetId: null,
  questionId: null,
  answerQuestion: () => { },
  leftLabel: '',
  rightLabel: '',
};

NPS.displayName = 'NPS';
export default NPS;
